/**
 * Date utility functions using dayjs
 */

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

// Extend dayjs with plugins once
dayjs.extend(relativeTime);

/**
 * Format date as relative time (e.g., "2 hours ago")
 */
export function formatRelativeTime(date: string | Date): string {
  try {
    const d = dayjs(date);
    if (!d.isValid()) {
      return "Invalid date";
    }
    return d.fromNow();
  } catch (error) {
    return "Invalid date";
  }
}

/**
 * Format date as absolute time (e.g., "Feb 19, 2026 10:00 AM")
 */
export function formatAbsoluteTime(date: string | Date): string {
  try {
    const d = dayjs(date);
    if (!d.isValid()) {
      return "Invalid date";
    }
    return d.format("MMM D, YYYY h:mm A");
  } catch (error) {
    return "Invalid date";
  }
}

/**
 * Check if date is valid
 */
export function isValidDate(date: string | Date): boolean {
  return dayjs(date).isValid();
}
